var map = {
	"./city-of-cape-town.png": 3270,
	"./msa.png": 7068,
	"./pwc.png": 4788,
	"./region-wallonne.png": 5434,
	"./ville-de-bruxelles.png": 827,
	"./ville-de-nice.png": 8061
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9454;